import { Injectable, OnDestroy } from '@angular/core';

export interface Timer {
  timeout: number;
  action: string;
}

@Injectable({
  providedIn: 'root'
})
export class TimerService implements OnDestroy {
  public activeTimers: Timer[] = [];
  private intervalIds: any[] = [];

  constructor() {
    this.initializeTimers();
  }

  public registerTimer(time: number, action: string) {
    if (!this.activeTimers.some(x => x.action === action && x.timeout === time)) {
      this.activeTimers.push({ timeout: time, action: action });
      localStorage.setItem('tasks', JSON.stringify(this.activeTimers));
      this.initializeTimers();
    }
  }

  private initializeTimers() {
    const tasksData = localStorage.getItem('tasks');
    if (!tasksData) return;

    try {
      const StorageTimers: Timer[] = JSON.parse(tasksData);
      if (StorageTimers != null) {
        for (const timerResult of StorageTimers) {
          const isAlreadyRegistered = this.intervalIds.some(() =>
            this.activeTimers.some(t => t.action === timerResult.action && t.timeout === timerResult.timeout)
          );

          if (!isAlreadyRegistered) {
            this.activeTimers.push(timerResult);

            const intervalId = setInterval(() => {
            }, timerResult.timeout * 1000);

            this.intervalIds.push(intervalId);
          }
        }
      }
    } catch (e) {
      console.error('Failed to parse timers from localStorage:', e);
    }
  }

  public ngOnDestroy(): void {
    this.intervalIds.forEach(intervalId => clearInterval(intervalId));
    this.intervalIds = [];
  }
}
